import { useApplicationContext } from 'shared/utils/applicationContext';
import { Microfrontend } from '@cian/mf-react';
import { IWidgetManifest } from 'shared/types/widgetManifest';
import { useEffect, useRef } from 'react';
import type { ICianMFUIElement } from '@cian/mf-registry/browser';
import { ECalculatorEvent } from 'shared/constants/calculatorEvents';
import { ERuntimeSettings } from '../../../types/runtimeSettings';

interface ICalculatorMicrofrontendProps {
  onSubmitCalculatorEvent(e: CustomEvent): void;
  onCatchErrorCalculatorEvent(e: CustomEvent): void;
  onSendAnalyticsCalculatorEvent(e: CustomEvent): void;
}
/* istanbul ignore next */
export const CalculatorMicrofrontend = ({
  onSubmitCalculatorEvent,
  onCatchErrorCalculatorEvent,
  onSendAnalyticsCalculatorEvent,
}: ICalculatorMicrofrontendProps) => {
  const { config, logger } = useApplicationContext();
  const mcfRef = useRef<ICianMFUIElement>(null);
  const manifest = config.get<IWidgetManifest>(ERuntimeSettings.offerCalculatorManifest);

  useEffect(() => {
    if (mcfRef?.current) {
      mcfRef.current.addEventListener(ECalculatorEvent.onSubmit, onSubmitCalculatorEvent);
      mcfRef.current.addEventListener(ECalculatorEvent.onError, onCatchErrorCalculatorEvent);
      mcfRef.current.addEventListener(ECalculatorEvent.onAnalytics, onSendAnalyticsCalculatorEvent);
    }
  }, [mcfRef, onSubmitCalculatorEvent, onCatchErrorCalculatorEvent, onSendAnalyticsCalculatorEvent]);

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта Ипотечного Калькулятора offer-calculator', {
      domain: 'microfrontends.offer-calculator.manifest',
    });

    return null;
  }

  return <Microfrontend {...manifest} ref={mcfRef} />;
};
